const Header = {
    handleFixedHeader: () => {
        var currentScrollTop = 0, navbar = $('.header');
        
        if ($(window).width() < 400) {
            navbar.removeClass('top-hidden');
            return;
        }

        var a = $(window).scrollTop();

        currentScrollTop = a;

        if (currentScrollTop > 48) {
            navbar.addClass('top-hidden');
        } else {
            navbar.removeClass('top-hidden');
        }
    },

    init: () => {
        $('#toggle-mobile-menu').click(function() {
            $('.header.-mobile').toggleClass('expanded');
            $('#mobile-bottom-menu').toggleClass('expanded');
            if ($('.submenu-mobile').hasClass('expanded')) {
                $('.submenu-mobile').removeClass('expanded');
            }
        });

        $('[data-toggle="submenu-mobile"]').click(function() {
            var target = $(this).data('target');
            if ($(target).hasClass('expanded')) {
                $('.submenu-mobile').removeClass('expanded');
            } else {
                $('.submenu-mobile').removeClass('expanded');
                $(target).addClass('expanded')
            }
        });

        $('[data-toggle="submenu"], .submenu').mouseover(function() {
            $(this).addClass('hovered');
        })

        $('[data-toggle="submenu"], .submenu').mouseout(function() {
            $(this).removeClass('hovered');
        })

        $('[data-toggle="submenu"]').mouseover($.debounce(function(e) {
            if (!$(e.target).hasClass('hovered')) {
                return;
            }

            $('[data-toggle="submenu"]').removeClass('active');
            $('.submenu').removeClass('expanded');
            $(e.target).addClass('active');
            $($(e.target).data('target')).addClass('expanded');
        }, 200));


        $('.submenu').mouseout($.debounce(function() {
            if (!$('.submenu.expanded').hasClass('hovered')) {
                $('.submenu.expanded').removeClass('expanded');
                $('[data-toggle="submenu"]').removeClass('active');
            }
        }, 200));

        
        $(window).resize(Header.handleFixedHeader);
        $(window).scroll(Header.handleFixedHeader);
    },
}

Object.freeze(Header);

export default Header;


// WEBPACK FOOTER //
// ./scripts/components/Header.js